import { useEffect, useState } from "react";
import styled from 'styled-components';
import { t } from '@lingui/core/macro';
import ResultList from "./ResultList";
import useStories from "./UseStories";
import {
  getTranslation
} from "./Utility.js"

const Input = styled.input`
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  margin-bottom: 1rem;
  background:papayawhip;
`;

const ResultContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  padding: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
  background:#f2dcceb5;
`;

const AutoCompleteContainer = styled.div`
  padding: 1rem;
  margin-top: 2rem;
  /* height: 20vh; */
`;

const HelperText = styled.div`
  font-size: 0.75rem;
  color: #ccc;
`;

/**
 * A component to display an autocomplete search form
 * @param {object} props
 * @returns {JSX.Element}
 */
export function AutocompleteSearch(options) {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(() => {
  }, []);

// Call for searched stories
  const { stories, loading } = useStories(
    "http://localhost:3000/api/items",
    searchTerm
  );

/**
   * A function that handles a search data change
   * @param {object} e - An event dom object
   * @returns {void} Set variables of state
   */
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

/**
   * A function that handles a select search data
   * @param {object} e - An event dom object
   * @returns {void} Call an option function or return boolean if fail
   */
  const handleSelect = (element) => {
    if (!element) {
      return false;
    }
    if (element.position && options.updateMap) {
      options.updateMap(element);
    }

  };

/**
   * A function that handles a key type event search data
   * @param {object} e - An event dom object
   * @returns {void} Set variables of state
   */
  const onKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      setActiveIndex((prev) => (prev + 1) % stories.length);
    }
    if (event.key === "ArrowUp") {
      setActiveIndex((prev) => (prev - 1 + stories.length) % stories.length);
    }
    if (event.key === "Enter") {
      if(stories && stories.length > 0){
      setSearchTerm(stories[activeIndex].name);
      }

    }
  };


  return (
    <AutoCompleteContainer>
      <Input
      list="stories"
        onChange={handleChange}
        onKeyDown={onKeyDown}
        value={getTranslation(searchTerm)}
        placeholder={t`Search`}
      />
      <datalist id="stories">
<option value="Archaeological site">{t`Archaeological site`}</option>
<option value="Catholic church">{t`Catholic church`}</option>
<option value="Museum">{t`Museum`}</option>
<option value="Tourist attraction">{t`Tourist attraction`}</option>
</datalist>
 {searchTerm ? (
        <ResultContainer>
          <ResultList
            results={stories}
            searchTerm={searchTerm}
            loading={loading}
            handleSelect={handleSelect}
            activeIndex={activeIndex}
          />
        </ResultContainer>
      ) : (
        <HelperText>{t`Start typing to search`}</HelperText>
      )}
    </AutoCompleteContainer>
  );
}

export default AutocompleteSearch;